module.exports = __webpack_public_path__ + "edit_icon_simple.svg?2e97c93184357c40c527633b8f6f81a4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/edit_icon_simple.svg
// module id = 36
// module chunks = 0